module.exports = __webpack_public_path__ + "img/popup-dashboard.45d41f02.svg";